import React from 'react';
import { Center, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import useForgotPasswordEmail from './useForgotPasswordEmail';
import ForgotPasswordContainer from './ForgotPassword.container';
import ForgotPasswordEmailContext from './ForgotPasswordEmail.context';
import ForgotPasswordEmailSuccess from './ForgotPasswordEmail.success';

const ForgotPasswordEmailPage: React.FC = () => {
  const { onSubmit, form, loading, error, success, reset } = useForgotPasswordEmail();

  return (
    <ForgotPasswordContainer>
      {success ? (
        <ForgotPasswordEmailSuccess reset={reset} form={form} />
      ) : (
        <ForgotPasswordEmailContext
          onSubmit={onSubmit}
          form={form}
          loading={loading}
          error={error}
        />
      )}
      <Center>
        <Text mt="lg">
          <Link to="/login">Back to Login</Link>
        </Text>
      </Center>
    </ForgotPasswordContainer>
  );
};

export default ForgotPasswordEmailPage;
